export const routes = {
  HOME: '/home',
  PROFILE: '/profile',
  LOGIN: '/',
  INVITATION: '/invitation',
  FIRMWARE_UPDATES: '/firmware-updates.html',
};



// WEBPACK FOOTER //
// ./src/static/routes.ts